import {useState} from 'react'
import {Button, Form} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {useAppSelector} from '../../../../../redux/hooks'
import {appSelector} from '../../../../../redux/slices/appSlices'
import {ModalProductSelection} from './ModalProductSelection/ModalProductSelection'

export const SelectProduct = () => {
  const {t} = useTranslation()
  const [showModal, setShowModal] = useState(false)
  const {jbpDetail: jbp} = useAppSelector(appSelector)

  return (
    <Form.Group controlId='formBasicEmail'>
      <Form.Label>{t('Product Code')}</Form.Label>
      <div className='d-flex'>
        <Form.Control
          size='sm'
          className='me-1'
          type='text'
          placeholder={t('Product Code')}
          value={jbp?.product_code ?? ''}
          disabled
        />
        <Button size='sm' className='btn btn-primary' onClick={() => setShowModal(true)}>
          {t('Browse')}
        </Button>

        <ModalProductSelection showModal={showModal} onCloseModal={() => setShowModal(false)} />
      </div>
    </Form.Group>
  )
}
